import { translate, translationExists } from '/b2b/common/helpers/i18n';

// Requirement identifiers are the scan payload's `requirement` values (see SCAN_REQUIREMENTS), which
// double as the locale namespace for everything a check displays — `requirement`, `successLabel`,
// `failureLabel` — so the explanation hangs off the same namespace.
const normalizeRequirement = requirement => `${requirement || ''}`.trim();

export const WHY_IT_MATTERS_PREFIX = 'domains.siteScan';
export const WHY_IT_MATTERS_LABEL = 'domains.siteScan.whyItMatters';

export const getWhyItMattersPath = requirement =>
    `${WHY_IT_MATTERS_PREFIX}.${normalizeRequirement(requirement)}.whyItMatters`;

/** The check's own name, used to say which check the explanation belongs to. */
export const getRequirementLabelPath = requirement =>
    `${WHY_IT_MATTERS_PREFIX}.${normalizeRequirement(requirement)}.requirement`;

/**
 * True when the check has a Legal-approved explanation. Callers use this to decide whether to render
 * the affordance at all, so a requirement the scanner starts returning before Legal has signed off
 * on copy shows its results without an empty dialog behind a button.
 */
export const hasWhyItMatters = requirement =>
    !!normalizeRequirement(requirement) && translationExists(getWhyItMattersPath(requirement));

export const getWhyItMatters = requirement =>
    hasWhyItMatters(requirement) ? translate(getWhyItMattersPath(requirement)) : '';
